<div class="bg-image flex-grow-1">
  <router-outlet/>
</div>
